import script from "./CustomAmountInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomAmountInput.vue?vue&type=script&setup=true&lang=ts"

import "./CustomAmountInput.vue?vue&type=style&index=0&id=a7b7f160&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7b7f160"]])

export default __exports__